export default {
  // prod: 'http://localhost:8081',
  prod: "",
  secret: "$$$ecommerce$$$",
  secretShare: "$ecom_share$",
};
